import { skMeetingEventParamenter } from "./interface";
import { cr, ck, URLS } from "fire-wind-water";
import info from "./status";
const w = window as any;

class Meeting {
  static modules: { [label: string]: string | any }[] = [];
  tenantId = URLS.getURL("tenantId");
  instanceId = URLS.getURL("instanceId");
  webinarId = URLS.getURL("webinarId");
  cookie: string;
  isLogin: boolean;
  returnUrl: string;
  loginUrl: string;
  isWeChatBrowser: boolean;
  registrationForm: any;
  device: boolean;
  device1: string;
  customFormId: string;
  customForm: any;
  htmlArray: any;
  tc: string;
  isMobile: boolean;
  info: any = {};
  webinarInfo: any = {};
  userInfo: any = {};

  constructor() {
    this.cookie = "";
    this.isLogin = false;
    this.returnUrl = window.location.href;
    this.loginUrl = "";
    this.isWeChatBrowser =
      navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
    this.registrationForm = {};
    this.device = !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
    this.device1 = "";
    this.customFormId = URLS.getURL("customFormId");
    this.customForm = null;
    this.htmlArray = null;
    this.tc = URLS.getURL("tc");
    this.isMobile = !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
  }

  // 根据会议参数，进行判断
  init(data) {
    if (data.type == "demand") {
      //点播逻辑
    } else {
      //直播或回看逻辑
      console.log("会议初始化", data);
      this.webinarInfo = data;
      //向 user 通知 发送会议数据
      info.meeting.initEdn.next(data);
      if (!ck.cookie("globalUserId")) {
        w.$sk.template.get().updateCookieId();
      }
      // this.skMeetingLinkEnd(this.webinarInfo);
      //向 module 通知 发送会议数据完成
      info.meeting.mettingEnd.next(true);
    }
    this.injectionListen();
  }
  injectionListen() {
    //监听用户信息改变
    info.user.userInfoChange.subscribe((userInfo) => {
      console.log("%c 监听到用户信息发生改变", "color:red", userInfo);
      this.userInfo = userInfo;
    });
    //监听 会议信息 发生改变
    info.meeting.mettingChange.subscribe((data: any) => {
      console.log("%c 会议信息发生改变", "color:red", data);
      this.webinarInfo = data;
      this.skMeetingChange(data);
    });
  }
  module(o) {
    const key = `sk_temp_webinar_meeting_${new Date().getTime()}`;
    Meeting.modules.push({
      key,
      model: o,
    });
    return {
      unsubscribe() {
        Meeting.modules = Meeting.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }
  // 会议状态发生变化，通知外部
  skMeetingChange(data) {
    cr.each(Meeting.modules, (d) => {
      if (d.model.skMeetingChange) {
        console.log("会议状态发生变化，通知外部", data);
        d.model.skMeetingChange(data);
      }
    });
  }
  //向外部 暴露 sk metting 接口
  skMeetingEvent(o: skMeetingEventParamenter) {
    console.log(o);
    // switch (o.type) {
    // }
  }
  canJoin(webinar, user) {
    const cookie = ck.cookie("smarketMember_" + webinar.schemaId);
    const isLogin = cookie !== "" && cookie != null;
    if (!webinar.isClosed && webinar.isReleased) {
      //未关闭 比去并且已经释放
      if (webinar.isOpen) {
        if (
          (isLogin || user.isRegistration) &&
          (!user.hasPermission || user.isDelete)
        ) {
          //已经登录 或者已经注册   并且
          return false;
        }
      } else {
        //未开放
        if (
          (webinar.needLogin &&
            webinar.needRegistration &&
            isLogin &&
            user.isRegistration) ||
          (webinar.needLogin && !webinar.needRegistration && isLogin) ||
          (!webinar.needLogin &&
            webinar.needRegistration &&
            user.isRegistration) ||
          webinar.unLimit
        ) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }
  canEnter(webinar, user) {
    const cookie = ck.cookie("smarketMember_" + webinar.schemaId);
    const isLogin = cookie !== "" && cookie != null;
    if (
      (webinar.needLogin &&
        webinar.needRegistration &&
        isLogin &&
        user.isRegistration) ||
      (webinar.needLogin && !webinar.needRegistration && isLogin) ||
      (!webinar.needLogin && webinar.needRegistration && user.isRegistration) ||
      webinar.unLimit
    ) {
      return true;
    }
  }
}

export { Meeting };
